import React, { Suspense, lazy } from 'react';

const PressLandingPageWrapper = lazy(() => import('./pressLandingPageWrapper'));

export const PressLandingPageWrapperLazy = () => {
    return (
        <Suspense fallback={<div>loading...</div>}>
            <PressLandingPageWrapper />
        </Suspense>
    );
};
